import htmx from 'htmx.org';

const TRIGGER_SELECTOR = '[data-open-clinical-admission]';

function processTriggers(root: ParentNode) {
  root.querySelectorAll<HTMLElement>(TRIGGER_SELECTOR).forEach(trigger => htmx.process(trigger));
}

function initClinicalAdmission() {
  const dialog = document.querySelector<HTMLDialogElement>('#clinical-admission-modal');
  const body = document.getElementById('clinical-admission-modal-body');
  if (!dialog || !body || dialog.dataset.bound === 'true') return;
  dialog.dataset.bound = 'true';
  let opener: HTMLElement | null = null;

  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const element = event.target instanceof Element ? event.target : null;
    const trigger = element?.closest<HTMLElement>(TRIGGER_SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    if (!dialog.open) dialog.showModal();
    body.innerHTML = '<div class="admission-modal-loading" role="status"><i class="ph ph-circle-notch" aria-hidden="true"></i><span>Preparando admisión...</span></div>';
  });

  dialog.querySelectorAll('[data-close-clinical-admission]').forEach(button =>
    button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });

  const targetsModal = (event: Event) =>
    event.target === body || (event as CustomEvent).detail?.target === body;

  const hasAdmissionErrorView = (event: Event) => {
    const xhr = (event as CustomEvent).detail?.xhr as XMLHttpRequest | undefined;
    return xhr?.getResponseHeader('X-Profint-Admission-View') === 'identity-error'
      && (xhr.getResponseHeader('Content-Type') || '').includes('text/html');
  };

  document.body.addEventListener('htmx:beforeSwap', event => {
    if (!targetsModal(event) || !dialog.open || !hasAdmissionErrorView(event)) return;
    // The controller returned the admission form with a safe error message.
    // Keep its HTTP error status and let the operator retry the same DNI.
    (event as CustomEvent).detail.shouldSwap = true;
  });

  document.body.addEventListener('htmx:afterSwap', event => {
    if (!targetsModal(event) || !dialog.open) return;
    const entry = body.querySelector<HTMLInputElement>(
      '[data-admission-panel]:not([hidden]) input[data-admission-entry]:not(:disabled)'
    );
    if (entry?.getClientRects().length) {
      entry.focus({ preventScroll: true });
      entry.select();
      return;
    }
    const focusTarget = Array.from(body.querySelectorAll<HTMLElement>(
      'input:not([type="hidden"]):not(:disabled), button:not(:disabled), a[href]'
    )).find(element => element.getClientRects().length > 0);
    focusTarget?.focus({ preventScroll: true });
  });

  const showError = (event: Event) => {
    if (!targetsModal(event) || !dialog.open || hasAdmissionErrorView(event)) return;
    body.innerHTML = '<div class="admission-modal-loading" role="alert"><i class="ph ph-warning-circle" aria-hidden="true"></i><span>No pudimos cargar la admisión. Volvé a intentarlo o usá «Abrir pantalla completa».</span></div>';
  };
  ['htmx:responseError', 'htmx:sendError', 'htmx:timeout'].forEach(name =>
    document.body.addEventListener(name, showError));

  processTriggers(document);
  window.addEventListener('profint:navigation:ready', event => {
    const root = (event as CustomEvent).detail?.root;
    if (root instanceof Element) processTriggers(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initClinicalAdmission, { once: true });
} else {
  initClinicalAdmission();
}
